<p-dialog [(visible)]="displayDialog" [modal]="true" [style]="{width: '500px','min-height':'550px'}" (onHide)="cancel()">
    <ng-template pTemplate="header">
        <div class="w-full text-center font-20" translate>off_balance_account_statement.title
        </div>
    </ng-template>

    <div class="" id="dialog">
        <form #form="ngForm" (ngSubmit)="save()" class="w-100" id="balanceForm" >

                <div class="mt-3">
                    <div class="row">
                        <div class="col-12 m-auto">
                            <div class="row h-68">
                                <div class="col-5 text-right pr-0 font-14">
                                    <label class="input-label">
                                        <span translate>customer_mngt.customer_table.account_number</span></label>
                                </div>
                                <div class="col-7">
                                    <input type="text" value="{{accountNumber}}" readonly
                                           class="form-control font-13">
                                </div>
                            </div>

                            <div class="row h-68">
                                <div class="col-5 text-right pr-0 font-14">
                                    <span class="input-label" translate>common.start_date</span>
                                </div>
                                <div class="col-7">
                                    <p-calendar [(ngModel)]="startDate" class="w-full custom-calendar"
                                                [showIcon]="true" [showOnFocus]="false"
                                                placeholder="dd-mm-yyyy" dateFormat="dd-mm-yy"
                                                [style]="{'width':'100%'}"appendTo="#dialog"
                                                [inputStyle]="{'width':'100%'}" name="fromDateObj"
                                                [monthNavigator]="true" [yearNavigator]="true"
                                                yearRange="2000:2099" required
                                                (ngModelChange)="changePeriodDate(true)"
                                                #fromDateObj="ngModel">
                                    </p-calendar>
                                    <small class="error-message-box">
                                        {{fromDateObj.valid || !submittedForm ? ' ' : 'This field is required'}}
                                    </small>
                                </div>
                                </div>

                            <div class="row">
                                <div class="col-5 text-right pr-0 font-14">
                                    <span class="input-label" translate>common.end_date</span>
                                </div>
                                <div class="col-7">
                                    <p-calendar [(ngModel)]="endDate" class="w-full custom-calendar"
                                                [showIcon]="true" [showOnFocus]="false"
                                                placeholder="dd-mm-yyyy" dateFormat="dd-mm-yy"
                                                [style]="{'width':'100%'}" appendTo="#dialog"
                                                [inputStyle]="{'width':'100%'}" name="endDateObj"
                                                [monthNavigator]="true" [yearNavigator]="true"
                                                yearRange="2000:2099" required
                                                (ngModelChange)="changePeriodDate(false)"
                                                #endDateObj="ngModel">
                                    </p-calendar>
                                    <small class="error-message-box">
                                        {{endDateObj.valid || !submittedForm ? '' : 'This field is required'}}
                                    </small>
                                </div>
                                </div>

                            <div class="row">
                                <div class="col-5 text-right pr-0 font-14">
                                    <span class="input-label" translate>common.period</span>
                                </div>
                                <div class="col-7">
                                <app-period-dropdown
                                  [periods]="periods"
                                  [(value)]="period"
                                  (valueChange)="calculatePeriod()"
                                  [optionValue]="'value'"
                                  [optionLabel]="'label'"
                                  [placeholder]="'Custom period'"
                                  [styleClass]="'inputfield w-full'"
                                  [scrollHeight]="'250px'">
                                </app-period-dropdown>
                            </div>
                            </div>
                            <div class="row">
                                <div class="col-5 text-right pr-0 font-14">
                                    <span class="font-14" translate>off_balance_account_statement.daily_turnover</span>

                                </div>
                                <div class="col-7">
                                    <input [(ngModel)]="showDailyTurnOvers" type="checkbox"
                                                             name="all-item"
                                                             class="form-check-input"
                                                             placeholder="">
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            <div class="d-flex justify-content-center pt-30">
                <div class="filter-actor">
                    <button id="ge" data-dismiss="modal"
                            class="btn btn-primary ml-4" tabindex="0" translate
                            (click)="save()">
                        buttons.generate
                    </button>

                    <button type="button" class="btn btn-light ml-10 px-20" translate
                            (click)="cancel()" aria-hidden="true" aria-label="Close">
                        buttons.cancel
                    </button>
                </div>
            </div>
        </form>
    </div>
</p-dialog>